import { gql } from "@apollo/client";

export const assetHierarchyLevel = gql`
  fragment assetHierarchyLevel on AssetHierarchyLevel {
    id
    name
    label
    level
    assetTypeId
    reverseLevel
  }
`;

export const assetHierarchy = gql`
  fragment assetHierarchy on AssetHierarchyDetail {
    id
    code
    name
    itemId
    imageUrl
    reverseLevel
  }
`;

export const assetData = gql`
  fragment assetData on Asset {
    assetId
    chassisNumber
    vehicleCategoryCode
    rcaCategoryId
    cascoCategoryId
    subcategoryId
    assetTypeId
    assetHierarchyId
    otherAssetName
    registrationTypeId
    registrationNumber
    engineType
    cylindricCapacity
    enginePower
    maxWeight
    seatsNumber
    manufacturingYear
    manufacturingMonth
    identityCardSeries
    currentMileage
    purchasePrice
    purchaseInvoiceDate
    firstRegistrationDate
    qtty
    description
    imageUrl
    equipment
    hierarchy {
      ...assetHierarchyLevel
    }
  }
  ${assetHierarchyLevel}
`;

export const offerAsset = gql`
  fragment offerAsset on OfferAsset {
    assetId
    purchasePrice
    firstRegistrationDate
    identityCardSeries
    manufacturingYear
    manufacturingMonth
    seatsNumber
    maxWeight
    enginePower
    cylindricCapacity
    currentMileage
    modelName
    brandName
    engineType
    registrationNumber
    subcategoryCode
    categoryCode
    vehicleCategoryCode
    qtty
    chassisNumber
    assetHierarchyId
    internalId
    currencyId
    currencyCode
    financingContractNumber
  }
`;
